import React, {useContext, useState} from 'react';
import '../Keyboard.css';
import {ThemeContext} from "../../../../../providers/themeContext/theme-context.tsx"; // 引入样式文件

type KeyProps = {
    label?: string;
    onPress: () => void;
}

const RemoveKey: React.FC<KeyProps> = ({onPress}) => {
    // 主题全局管理器
    const {imgUrls} = useContext(ThemeContext);
    const [pressed, setPressed] = useState(false);

    const handleKeyPress = () => {
        setPressed(true);
        setTimeout(() => setPressed(false), 200); // 按键后的状态持续时间
        onPress();
    };

    return (
        <img src={imgUrls.removeKeyboardBtnUrl} alt="pic"
            className={`keyboard-remove-btn ${pressed ? 'key-pressed' : ''}`}
            onClick={handleKeyPress} />
    );
};

export default RemoveKey;